import { get } from "lodash";

export const currentUser = (state) => get(state, "login.currentUser", null);
export const userToken = (state) => get(state, "login.token", "");
export const getRefreshToken = (state) =>
  get(state, "login.refreshToken", null);
export const getTokenExpiration = (state) =>
  parseInt(get(state, "login.tokenExpiration", null), 10);
